module.exports = __webpack_public_path__ + "img/guotai.363aa305.jpg";